<template>
    <a class="relative block overflow-hidden group" :href="url">
        <img
            class="object-cover object-center w-full h-full max-h-full lazyload"
            :data-srcset="image"
            data-sizes="(min-width: 1024px) 290px, 100vw"
            :alt="product.title"
            width="328"
            height="400"
        />

        <div class="absolute inset-0 transition-opacity duration-150 transform bg-gradient-medium">
            <div
                class="flex flex-col h-full p-8 text-white transition-transform duration-150 transform"
            >
                <div
                    class="absolute top-0 right-0 px-3 py-1 text-xs bg-teal-600 uppercase font-bold"
                >
                    {{ deal }}
                </div>
                <div class="mt-auto text-center">
                    <h3 class="leading-snug text-white text-lg font-medium mb-4">
                        {{ product.title }}
                    </h3>
                </div>
            </div>
        </div>
    </a>
</template>

<script>
import moment from 'moment';
import { truncate } from 'lodash';

export default {
    props: {
        product: {
            type: Object,
            required: true
        }
    },

    computed: {
        image() {
            // Need to account for old and new deals fields
            if (this.product.roam_deals_image) {
                return this.product.roam_deals_image && this.product.roam_deals_image.join(', ');
            } else if (this.product.roam_deals_product_images) {
                return (
                    this.product.roam_deals_product_images &&
                    this.product.roam_deals_product_images.join(', ')
                );
            } else {
                return 'https://dummyimage.com/300x370/4E562B/fff.png&text=placeholder';
            }
        },
        url() {
            return this.product.roam_deals_product_url + '#Deals';
        },
        deal() {
            // Here too
            if (this.product.roam_deals_type.label) {
                if (this.product.roam_deals_type.label.toLowerCase() == 'specialrate') {
                    return 'Special Rate';
                } else if (this.product.roam_deals_type.label.toLowerCase() == 'bonusoffer') {
                    return 'Offer';
                } else {
                    return this.product.roam_deals_type.label;
                }
            } else {
                if (this.product.roam_deals_type.toLowerCase() == 'specialrate') {
                    return 'Special Rate';
                } else if (this.product.roam_deals_type.toLowerCase() == 'bonusoffer') {
                    return 'Offer';
                } else {
                    return this.product.roam_deals_type;
                }
            }
        }
    },

    methods: {
        trunc(string) {
            return truncate(string, { length: 100, seperator: '&hellip;' });
        },

        dates(dates) {
            if (!dates) return null;
            const from = moment.unix(dates[0]);
            const to = moment.unix(dates[dates.length - 1]);

            return from.isSame(to)
                ? `${from.format('MMM D, YY')}`
                : `${from.format('MMM D, YY')} - ${to.format('MMM D, YY')}`;
        }
    }
};
</script>
